import * as qs from 'qs'
import { hashHistory } from 'react-router'
import type { LocationDescriptorObject } from 'history'
import { Plat_savePathForRecovery } from '../Plat/Plat.androidRecovery'

export function Rout_construct(path: string, queryParameters?: any) {
    const queryString = qs.stringify(queryParameters, { skipNulls: true })
    return path + (queryString ? `?${queryString}` : '')
}

export function Rout_to(path: string, queryParameters?: any) {
    const fullPath = Rout_construct(path, queryParameters)
    hashHistory.push(fullPath)
    Plat_savePathForRecovery(fullPath)
}

export function Rout_replace(path: string, queryParameters?: any) {
    const fullPath = Rout_construct(path, queryParameters)
    hashHistory.replace(fullPath)
    Plat_savePathForRecovery(fullPath)
}

export function reloadPage() {
    Rout_replace(Rout_getPath())
}

export function Rout_replace_location(location: LocationDescriptorObject) {
    hashHistory.replace(location)
}

export function Rout_getPath() {
    return hashHistory.getCurrentLocation().pathname
}

export function Rout_back() {
    hashHistory.goBack()
}

export function replaceUrlOverridingQuery(key: string, ...values: any[]) {
    const { query, ...location } = hashHistory.getCurrentLocation()
    const urlWithNewFilters = hashHistory.createLocation({
        query: { ...query, [key]: values.length ? values : undefined },
        ...location,
    })
    Rout_replace_location(urlWithNewFilters)
}
